import React from 'react';
import { IconButton } from '@mui/material';
import { keyvaultrService } from '../KeyVaultService';
import KeyVaultConstants from '../Common/Constants';
import { RevealProps } from '../Model/KeyVaultProps';
import { ThemedCopyIcon } from '../../../../Common/Components/Icons';
import { useTranslation } from 'react-i18next';
import { showToast } from '../../../../lib/toast';

const Reveal: React.FC<RevealProps> = ({ KeyId }) => {
  const { t } = useTranslation('keyvault');
  const getSecretAsString = (value: string): string =>
    typeof value === 'object' ? JSON.stringify(value) : value;

  const toastforSecretCopy = () =>
    showToast({
      title: t(KeyVaultConstants.SecretCoppied),
      type: 'success',
    });

  const loadKeyValue = async () => {
    try {
      const KeyValue = await keyvaultrService.RevealKeyValue(KeyId);
      const value = getSecretAsString(KeyValue);
      await navigator.clipboard.writeText(value);
      toastforSecretCopy();
    } catch (error) {
      showToast({
        title: t((error as Error).message),
        type: 'error',
      });
      console.error(error);
    }
  };

  return (
    <IconButton onClick={loadKeyValue}>
      <ThemedCopyIcon fontSize="small" />
    </IconButton>
  );
};

export default Reveal;
